import { ApiRelationResponse, RelationInterface } from '../interfaces';

export function mapRelationResponse(response: ApiRelationResponse): RelationInterface {
    return response.relation;
}
